import { MySsApiResponseData } from '~/types/MySsApiResponse';
import { Redemption, RedemptionListFilters } from '~/models/Redemption';
import {
  RedemptionAdapter,
  RedemptionListFiltersAdapter,
} from '~adapters/RedemptionAdapter';
import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { getRedemptions } from '~/services/apiMyAccount';
import { useAuthStore } from '~/stores/useAuthStore';
import { useTimer } from '~/composables/useTimer';

export const useRedemptionStore = defineStore(
  'REDEMPTION_STORE',
  () => {
    const AUTH_STORE = useAuthStore();
    const PROFILE_STORE = useProfileStore();

    const { profile } = storeToRefs(PROFILE_STORE);

    const timer = useTimer();

    const redemptionList = ref<any>([]);
    const redemptionListFilters = ref<RedemptionListFilters>(new RedemptionListFilters());
    const loadingRedemptionList = ref<boolean>(false);

    const isLoadingRedemptionList = computed(() => loadingRedemptionList.value);
    const getRedemptionList = computed(() => redemptionList.value);

    function setRedemptionList(data: Redemption[] | null) {
      if (!data) redemptionList.value = [];
      else redemptionList.value = [...data];
    }

    function resetRedemptionListFilters() {
      redemptionListFilters.value = new RedemptionListFilters();
    }

    function toggleLoadingRedemptionList() {
      loadingRedemptionList.value = !loadingRedemptionList.value;
    }
    async function dispatchGetRedemptions(
      force: boolean = false,
      params: RedemptionListFilters = {} as RedemptionListFilters,
    ) {
      if(profile.value.isCommercial) return
      if (!timer.isExpired.value && !force) return;

      const _params = RedemptionListFiltersAdapter.toDto({
        ...redemptionListFilters.value,
        ...params,
      });

      toggleLoadingRedemptionList();

      await getRedemptions(AUTH_STORE.session.currentEconomicGroupMember, _params).then(
        ({ data }: MySsApiResponseData) => {
          setRedemptionList(data.map(RedemptionAdapter.toView));
          timer.startTimer();
          toggleLoadingRedemptionList();
        },

        (error) => {
          setRedemptionList(null);
          toggleLoadingRedemptionList();
          throw error;
        },
      );
    }

    function $reset() {
      setRedemptionList(null);
      resetRedemptionListFilters();
    }

    return {
      isLoadingRedemptionList,
      redemptionList: getRedemptionList,
      redemptionListFilters,
      dispatchGetRedemptions,
      onSessionOpen: dispatchGetRedemptions,
      onSessionClose: $reset,
      onChangeEconomicGroup: dispatchGetRedemptions,
      resetRedemptionListFilters,
    };
  },
  { persist: true },
);
